import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import cx from 'classnames';

// Lodash
import _isFunction from 'lodash/isFunction';

// Constants
import SORT_ORDER from '@tekion/tekion-base/constants/sortOrder';

// Components
import Icon, { SIZES } from '../../../../atoms/FontIcon';

// Styles
import style from './headerWithSort.module.scss';
var HeaderWithSort = function HeaderWithSort(props) {
  var Header = props.headerTitle,
    sortType = props.sortType,
    isRightAlign = props.isRightAlign,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: onClick,
    className: cx(style.centerAlignHeader, style.noOutline, _defineProperty({}, style.rightAlign, isRightAlign))
  }, _isFunction(Header) ? /*#__PURE__*/React.createElement(Header, null) : /*#__PURE__*/React.createElement("div", null, Header), /*#__PURE__*/React.createElement(Icon, {
    size: SIZES.S,
    className: cx(style.accordian, _defineProperty({
      'icon-arrow-down': sortType === SORT_ORDER.DESC,
      'icon-arrow-up': sortType === SORT_ORDER.ASC
    }, "".concat(style.sortIndicator, " icon-sort-by"), !sortType))
  }));
};
export default HeaderWithSort;